exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width: 1024px){.mobile-only[data-v-8af07ee8]{display:none !important}}@media (max-width: 1023px){.desktop-only[data-v-8af07ee8]{display:none !important}}.o-modal[data-v-8af07ee8]{position:relative;z-index:var(--modal-index)}.modal[data-v-8af07ee8]{-webkit-box-sizing:border-box;box-sizing:border-box}@media (min-width: 1024px){.modal[data-v-8af07ee8]{max-width:1272px;margin:auto}}\n", ""]);

// exports
